module.exports = __webpack_public_path__ + "videos/Gpt-Slow.e4223a7.mp4";